/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TerminiVersioneDTO { 
    enabled?: boolean;
    versione_corrente?: string;
    testo_html?: string;
}

